var ChatHelp = React.createClass({
  mixins: [React.addons.PureRenderMixin],

  render: function() {
    var arrow = <span style={{
      color: 'lime'
    }}>➡</span>
    return (
      <div>
				<h1>Chat Help!</h1>
				<hr />
				<h2>Markup</h2>
				<ul>
					<li>Single word tags</li>
					<ul>
						<li>
							*bold* {arrow} <b>bold</b>
						</li>
						<li>
							/italics/ {arrow} <i>italics</i>
						</li>
						<li>
							_underline_ {arrow} <u>underline</u>
						</li>
						<li>
							-strike- {arrow} <s>strike</s>
						</li>
					</ul>
					<br />
					<li>Full message Tags (Must be first character)</li>
					<ul>
						<li>
							*bold all the things {arrow} <b>bold all the things</b>
						</li>
						<li>
							/italics all the things {arrow} <i>italics all the things</i>
						</li>
						<li>
							_underline all the things {arrow} <u>underline all the things</u>
						</li>
						<li>
							-strike all the things {arrow} <s>strike all the things</s>
						</li>
					</ul>
					<br />
					<li>Arithmetic (Do not include spaces)</li>
					<ul>
						<li>5+5 {arrow} calculator: 10</li>
						<li>5-5 {arrow} calculator: 0</li>
						<li>5*5 {arrow} calculator: 25</li>
						<li>5/5 {arrow} calculator: 1</li>
						<li>(5+5)*(5/5) {arrow} calculator: 10</li>
					</ul>
				</ul>
				<hr />
				<SeeAlso />
			</div>
    )
  },
})